<template>
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.5 5L5.5 2H0.5V13.5C0.5 13.8978 0.658035 14.2794 0.93934 14.5607C1.22064 14.842 1.60218 15 2 15H14C14.3978 15 14.7794 14.842 15.0607 14.5607C15.342 14.2794 15.5 13.8978 15.5 13.5V5H7.5Z"
      fill="#E4E4E7"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
